// Fetch wrapper for endpoints that require a live session. On 401 it triggers
// the session-expired flow (clear user, toast) then rethrows. Public endpoints
// should use baseFetch directly.

import { baseFetch, ApiFetchError, type BaseFetchOptions } from './baseFetch';
import { notifySessionExpired } from './sessionPolicy';
import type { SuccessResponse } from '@airhead-games/shared/types';

export async function protectedFetch<TReq = unknown, TRes = unknown>(
  path: string,
  options: BaseFetchOptions<TReq> = {}
): Promise<SuccessResponse<TRes>> {
  try {
    return await baseFetch<TReq, TRes>(path, options);
  } catch (error) {
    if (error instanceof ApiFetchError && error.status === 401) {
      notifySessionExpired();
    }
    throw error;
  }
}
